export const queryKeys = {
  store: {
    all: ['store'] as const,
    byDomain: (domain: string) => [...queryKeys.store.all, 'byDomain', domain] as const,
  },
  subscriptions: {
    all: ['subscriptions'] as const,
  },
  orders: {
    all: ['orders'] as const,
    list: (page: number, pageSize: number) =>
      [...queryKeys.orders.all, 'list', { page, pageSize }] as const,
    detail: (id: string) => [...queryKeys.orders.all, 'detail', id] as const,
  },
  account: {
    all: ['account'] as const,
  },
} as const;
